import React from 'react';

export default function DealFormStepper({ visibleSteps, step, goToStep }) {
    return (
        <div className="deal-form-stepper" id="dealFormStepper" data-active-step={step}>
            {visibleSteps.map((s, i) => (
                <React.Fragment key={s.key}>
                    {i > 0 && (
                        <div
                            className={`deal-stepper-connector${i <= step ? ' is-active' : ''}`}
                            id={`stepperConnector${i}`}
                        />
                    )}
                    <div
                        className={`deal-stepper-step${i === step ? ' is-current' : ''}`}
                        data-stepper-tab={s.key}
                        aria-current={i === step ? 'step' : undefined}
                        onClick={() => goToStep(i)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                goToStep(i);
                            }
                        }}
                    >
                        <span
                            className={`deal-stepper-circle${i < step ? ' is-complete' : ''}${i === step ? ' is-current' : ''}${i > step ? ' is-inactive' : ''}`}
                            id={`stepperCircle${i + 1}`}
                        >
                            {i + 1}
                        </span>
                        <span
                            className={`deal-stepper-label${i === step ? ' is-current' : ''}${i > step ? ' is-inactive' : ''}`}
                            id={`stepperLabel${i + 1}`}
                        >
                            {s.label}
                        </span>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
}
